import i18n from 'i18n-literally'

import * as flowConstants from '~/src/Flow/constants'

export const MAX_PLANT_BATCH_SIZE = 100

export const GROWTH_PHASES = Object.freeze(['YOUNG', 'VEG', 'FLOWER'])
export const PHASE_TYPES = Object.freeze(['PROP', 'VEG', 'FLOWER', 'DRY'])
export const CULTIVATION_PHASE_TYPES = Object.freeze(PHASE_TYPES.slice(0, -1))
export const PLANT_TYPES = Object.freeze(['CLONE', 'SEED'])
export const HARVEST_ROOM_TYPES = Object.freeze(PHASE_TYPES.map(name => name.toLowerCase()))
export const CULTIVATION_ROOM_TYPES = Object.freeze(HARVEST_ROOM_TYPES.slice(0, -1))
export const HARVEST_FLOWS = Object.entries(flowConstants).reduce((acc, [key, value]) => {
  if (!key.endsWith('_ROUTE') && `HARVEST_BASED_${key}_ROUTE` in flowConstants) acc.push(value)
  return acc
}, [])

export const PHASE_TYPE_LABELS = {
  get PROP() {
    return i18n`Propagation`
  },
  get VEG() {
    return i18n`Vegetative`
  },
  get FLOWER() {
    return i18n`Flowering`
  },
  get DRY() {
    return i18n`Drying`
  },
}

export const PHASE_TYPES_SELECT_OPTIONS = [
  {
    get label() {
      return i18n`No phase`
    },
    type: 'NONE',
    value: 5,
  },
  {
    get label() {
      return i18n`All phases`
    },
    type: null,
    value: 6,
  },
  {
    get label() {
      return i18n`${PHASE_TYPE_LABELS[this.type]} phase`
    },
    type: 'PROP',
    value: 1,
  },
  {
    get label() {
      return i18n`${PHASE_TYPE_LABELS[this.type]} phase`
    },
    type: 'VEG',
    value: 2,
  },
  {
    get label() {
      return i18n`${PHASE_TYPE_LABELS[this.type]} phase`
    },
    type: 'FLOWER',
    value: 3,
  },
  {
    get label() {
      return i18n`${PHASE_TYPE_LABELS[this.type]} phase`
    },
    type: 'DRY',
    value: 4,
  },
]
